import React, { Component } from 'react';
import ServerTable from '../../services/server-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCog, faTrash, faPlus} from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BrandModal from "./BrandModel";
import { ConfirmationDialog, SnapBarError } from "../../ConfirmationDialog";
import { WindowPanel } from "../../WindowPanel";
import AccessSecurity from '../../AccessSecurity';
const url = `admin/portal/brand`;

const PER_PAGE = process.env.REACT_APP_PER_PAGE;

class BrandList extends Component {
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.state = {
            modalShow: false,
            mode: '',
            dataview: [],
            totaldata: null,
            snapopen: false,
            snapcolor: null,
            error: null,
            deletedialog: false,
            proceed: false,
            renderTable: false,
            sysid: null,
            page: 1,
            deletesysid: '',
            security: [],
        };
        this.modalRef = React.createRef();
    }
    setModalShow = () => {
        this.setState({
            modalShow: true,
            mode: 'IS'
        });
    }

    closedialog = () => {
        this.setState({ deletedialog: false });
    }
    modalClose = () => {
        this.setState({ modalShow: false });
    }

    renderTable = () => {
        this.setState({
            renderTable: true
        }, () => {
            this.setState({ renderTable: false });
        });
    }

    duplicateRecord = (id, desc, lang) => {
        this.modalRef.current.editModalRecord(id, desc, lang, 'copy');
        this.setState({ modalShow: true, mode: 'IS' });
    }

    editRecord = (id, desc, lang) => {
        this.modalRef.current.editModalRecord(id, desc, lang);

        this.setState({ modalShow: true, mode: 'UP', sysid: id },
            () => { this.setState({ sysid: null }); });
    }

    deletRecord = (id) => {
        this.setState({ deletedialog: true, sysid: id });
    }


    proceedDelete = (params) => {
        if (params) {
            this.modalRef.current.deleteModalRecord(this.state.sysid);
        } else {

        }

    }

    snapclose = () => {
        this.setState({ snapopen: false });
    };
    handleClose = () => {
        this.setState({ open: false });
    };
    errorThrough = (error, argu) => {
        var erroMessage = '';
        if (argu === 'ERR-OBJ') {
            erroMessage = Object.keys(error).map(function (key) {
                return <ul key={key} className="mrgnone list-unstyled"><li>{error[key]}</li></ul>;
            });
        } else {
            erroMessage = <ul className="mrgnone list-unstyled"><li>{error}</li></ul>;
        }
        var backBrand = ((argu === 'ERR' || argu === 'ERR-OBJ') ? '#ff4c4ceb' : '#20bb20eb');
        this.setState({ snapopen: true, snapcolor: backBrand });
        this.setState({ error: erroMessage });
    }

    setsecurity = (param) => {
        //console.log(param.USER_ROLE)
        this.setState({ security: param });
    }

    render() {
       // let security = this.state.security;

        let self = this;

        let $button = (<OverlayTrigger overlay={<Tooltip id="tooltip">Add Brand</Tooltip>}>
            <button className="btn btn-primary btn-sm" onClick={this.setModalShow}>{<FontAwesomeIcon icon={faPlus} />}</button></OverlayTrigger>);
        const columns = ['sr_no', 'BR_CODE', 'BR_DESC', 'BR_IMAGE_PATH', 'BR_ACTIVE_YN', 'actions']; //, 'tag_id'
        const options = {
            perPage: PER_PAGE,
            headings: {
                sr_no: '#',
                BR_CODE: 'Brand Code',
                BR_DESC: 'Desc',
                BR_ACTIVE_YN: 'Active',
                BR_IMAGE_PATH: 'Image'
            },
            search_key: {
                BR_CODE: 'Brand Code',
                BR_DESC: 'Desc',
                BR_ACTIVE_YN: 'Active',
            },
            sortable: ['BR_CODE', 'BR_DESC', 'BR_ACTIVE_YN'], //'tag_id', 
            requestParametersNames: { search_value: 'search_value', search_column: 'search_column', direction: 'order' },
            columnsAlign: { actions: 'center' },
            responseAdapter: function (resp_data) {
                self.setState({ page: resp_data.page });
                return { data: resp_data.result, total: resp_data.row_count }
            },
            texts: {
                show: ''
            },
            search_lov: {
                pages: []
            }
        };

        return (
            <div>
                <AccessSecurity
                    accessecurity={this.setsecurity}
                />
                <SnapBarError
                    message={this.state.error}
                    snapopen={this.state.snapopen}
                    snapcolor={this.state.snapcolor}
                    snapclose={this.snapclose} />
                <ConfirmationDialog
                    dialogopen={this.state.deletedialog}
                    dialogclose={this.closedialog}
                    agreeProcess={this.proceedDelete}
                />
                <WindowPanel rawHtml={
                    <div className="windowContent">
                        <ServerTable renderView={this.state.renderTable} columns={columns} url={url} options={options} addme={$button} bordered hover updateUrl hist_table="SITE_M_SHOWROOM_HIST">
                            {
                                function (row, column, index) {
                                    switch (column) {
                                        case 'sr_no':
                                            return (
                                                (index + 1) + (PER_PAGE * ((self.state.page) - 1))
                                            );
                                        case 'BR_IMAGE_PATH':
                                            return (
                                                <img src={row.HTTP_IMAGE_PATH + row.BR_IMAGE_PATH} width="50px"></img>
                                            );
                                        case 'actions':
                                            return (
                                                <div className="form-control-sm" style={{ textAlign: 'center' }}>
                                                    <DropdownButton size="sm" id="dropdown-basic-button" title={<FontAwesomeIcon icon={faCog} />}>
                                                        <Dropdown.Item onClick={() => self.editRecord(row.BR_CODE, row.BR_DESC, 'en')}><FontAwesomeIcon icon={faEdit} /> Edit</Dropdown.Item>
                                                        {/* <Dropdown.Item onClick={() => self.duplicateRecord(row.BR_CODE, row.BR_DESC, 'en')}><FontAwesomeIcon icon={faCopy} /> Duplicate</Dropdown.Item>
                                                        <Dropdown.Item disabled={security.LANGUAGE_YN !== 'Y' ? true : false} onClick={() => self.editRecord(row.BR_CODE, row.BR_DESC, 'ar')}>
                                                            <FontAwesomeIcon icon={faLanguage} /> Edit Language
                                                        </Dropdown.Item> */}
                                                        <Dropdown.Item onClick={() => self.deletRecord(row.BR_CODE)}><FontAwesomeIcon icon={faTrash} /> Delete</Dropdown.Item>
                                                    </DropdownButton>
                                                </div>
                                            );
                                        default:
                                            return (row[column]);
                                    }
                                }
                            }
                        </ServerTable>

                        <BrandModal
                            ref={this.modalRef}
                            renderTable={this.renderTable}
                            editModal={this.editModal}
                            mode={this.state.mode}
                            show={this.state.modalShow}
                            closeModal={this.modalClose}
                            closeDelete={this.closedialog}
                            errorMessage={this.errorThrough}
                        />
                    </div>
                } />
            </div>
        );
    }
}

export default BrandList;